
import { ChangeDetectionStrategy, Component, forwardRef, ChangeDetectorRef, Input } from '@angular/core';
import { WizDropItemEvent, WIZ_DRAGGABLE_COMPONENT, WizRoot } from '@wizeoo/akm-component-lib';
import { EM_ACTION, FIELD_KIND, WizConstants } from '@wizeoo/akm-compute-lib';

import { FormWidgetGridsterComponent } from '../../form/generic/form-widget.gridster.component';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { GridType } from 'angular-gridster2';
import { ViewData } from '../../../../model/view.data';

@Component({
  selector: 'freedata-gridster',
  template: `
  <div class ="wrapper" width="100%" height="100%">
    <gridster #gridster [options]="options" width="100%" height="100%" class="gridster" tabindex="0" [style.background-color]="_backgroundColor">
      <gridster-item [item]="item" *ngFor="let item of filteredItems">
        <freedata-gridster-item
                [model]="model"
                [field]="item"        
                [freedataValue]="freedataValue" 
                [templatingMode]="templatingMode"
                (delete)="onItemDeleted($event)"></freedata-gridster-item>
      </gridster-item>
    </gridster>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: WIZ_DRAGGABLE_COMPONENT,
      useExisting: forwardRef(() => FreedataGridsterComponent),
    },
  ],
  styleUrls: ['../../form/generic/form-widget.gridster.component.scss']
})
export class FreedataGridsterComponent extends FormWidgetGridsterComponent {

  constructor(cdref: ChangeDetectorRef) {
    super(cdref);
  }

  _freeDataValueVO: FreedataValueVO;

  @Input() 
  set freedataValue(fdv: FreedataValueVO) {
    this._freeDataValueVO = fdv;
  }
  get freedataValue(): FreedataValueVO {
    return this._freeDataValueVO;
  }

  @Input() 
  public restrictSet: Map<string, string>;

  @Input() 
  public hiddenGroups: Map<string, boolean>;

  // map des champs masqués par règles de gestion
  public hiddenMap: Map<string, any> = new Map();

  /**
   * filtrer les éléments en restrict
   */
  public get filteredItems(): GridsterWidgetItem[] {
    if(this.templatingMode) {
      return this.widgets;
    } else {
      let res: GridsterWidgetItem[] = [];
      
      let needRefreshCoords: boolean = false;

      this.widgets?.forEach(gwi => {
        let pf: PivotField = (gwi.field as PivotField);
        let code: string = pf?.code;
        let filterKey: string = [pf?.contextItem.fdvf, pf?.contextItem.subField].join(WizConstants.KEY_SEPARATOR);
        // gestion des containers
        // TODO... intercepter...les args de type group
        let group: string = gwi.source?.pgrp || null;
        let groupHidden: boolean = false;
        if(!!group && gwi.source?.fdvf !== ViewData.FORM_ZONE) {
          if(!!this.hiddenGroups?.get(group)) {
            groupHidden = true;
            // console.log('yo', group, gwi);
          }
        }
        

        if(this.restrictSet?.has(code) || groupHidden) {
          this.hiddenMap.set(filterKey, {x: gwi.x, y: gwi.y});
          //console.log('hidden', gwi, (this.widget as any)?.restrictSet);
          // res.push(gwi);
        } else {
          if(this.hiddenMap.has(filterKey)) { // il était caché, on refresh ses coordonnées
            let good: any = this.hiddenMap.get(filterKey);
            this.hiddenMap.delete(filterKey);
            needRefreshCoords = true;
            // console.log('hidden', gwi, good);
            /** alimentation des coordonnées */ 
              // gwi.x = good.x;
              // gwi.y = good.y;
          }
          // console.log('order', (gwi.field as PivotField)?.code);
          res.push(gwi);
        }  
      });

      if(needRefreshCoords) { // un item réapparait, il faut recalculer les places
         // this.options.compactType = 'none';
        this.options.api?.optionsChanged();
        this.widgets.forEach(gwiBad => {
          // console.log('1',(gwiBad.field as PivotField)?.code, gwiBad.x, gwiBad.y, gwiBad.source.x, gwiBad.source.y);
          gwiBad.x = gwiBad.source.x;
          gwiBad.y = gwiBad.source.y;
          //console.log('2', (gwiBad.field as PivotField)?.code, gwiBad.x, gwiBad.y, gwiBad.source.x, gwiBad.source.y);
        });
        this.widgets.sort((a,b) => {
          return this.calculatedTabIndex(a) - this.calculatedTabIndex(b);
        })
        // retour à vide, il va rincer ses éléments
        return [];   
      }
      return res;
    }

  }


  onAddItemAfterDrag(pEvent: WizDropItemEvent): void {
    
    const item: GridsterWidgetItem = GridsterWidgetItem.constructFromGridster(this.gridster.emptyCell.getValidItemFromEvent(pEvent.event));
    let src = pEvent.item.data as PivotField;
    let newWcio = {...src.contextItem};
    item.field = new PivotField(src.widget, newWcio, null, src.arg);
    // item.field = pEvent.item.data as PivotField;
    item.source = newWcio; // {...item.field.contextItem}; // sinon perte des infos sur gridsterItem
    item.updateCoords();

    this._widgets = [item, ...this._widgets];

    // console.log('onAddItemAfterDrag FD gridster', item);
    this.widgetsChanged.emit({item, action: EM_ACTION.CREATE}); //this.widgetsChanged.emit(this._widgets);

    this.cdref.markForCheck();
  }

  checkDragOver(event: WizDropItemEvent): boolean {
    
    let result: boolean = false;
    this.gridster.emptyCell.emptyCellDragOver(event.event);

    let exist: GridsterWidgetItem;
    let dropEffect: string;

    if (!event.item.data.arg || event.item.data.arg.dataType === FIELD_KIND.OBJECT) { // plusieurs fois possibles pour un champ Objet et les libellés
      result = true;
    } else {
      exist = this._widgets.find(wo => (wo.field as PivotField).code === event.item.data.code);
      dropEffect = event.event.dataTransfer.dropEffect;
      if (!exist && dropEffect !== 'none') {
        result = true;
      }
    }
    // console.log('cdo', event, exist, dropEffect);
    return result;
  }

  public updateOptions() {
    let mode: GridType = null;
    if(WizRoot.isMobile()) {
      mode = GridType.ScrollVertical;
    }
    super.updateOptions(mode);
  }
}
